<script lang="ts" setup>
  import SinglePageContainer from "@/components/views/session/SinglePageContainer.vue";
  import { useSubscriptionFlowStore } from "@/stores/subscriptionFlow";
  import { useCardsStore } from "@/stores/cards";
  import Icon from "@/components/Icon.vue";
  import { CardStatus } from "@/models/card";
  import * as amplitude from "@amplitude/analytics-browser";

  const subscriptionFlowStore = useSubscriptionFlowStore();
  const cardsStore = useCardsStore();

  function handleAddNewCard() {
    amplitude.track('Add New Card', {
      "Inactive-Account Type": 'None',
      "In-App Location": 'Subscription Upgrade Flow',
    });
    subscriptionFlowStore.changeBillingStep('card-form');
  }

  function handleCancel() {
    subscriptionFlowStore.billingStep = 'checkout';
  }
</script>

<template>
  <div class="title">
    {{ $t('common.card.select') }}
  </div>
  <div class="cards">
    <div v-for="card in cardsStore.cards" :class="['card', card.status !== CardStatus.ACTIVE ? 'disabled' : '']">
      <img :src="cardsStore.getCardSystemLogo(card.system)" alt="Card system" class="card-system-logo"/>
      <span class="card-digits">{{ $t('account.card.ending.digits', { digits: card.lastDigits }) }}</span>
      <Icon v-if="card.status === 'active'" icon="chevron_right"
            @click="subscriptionFlowStore.selectCard(card.id)"></Icon>
      <div v-else-if="card.status === CardStatus.EXPIRED" class="expired">{{ $t('account.cards.expired') }}</div>
    </div>
  </div>
  <div class="actions">
    <v-btn class="full" color="primary" @click="handleAddNewCard">
      {{ $t('common.add-new-card') }}
    </v-btn>
  </div>
</template>

<style lang="scss" scoped>
  .cards {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .card {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;

      background-color: rgb(var(--v-theme-neutral-100));
      border-radius: 0.5rem;
      padding: 1rem;

      &.disabled {
        opacity: 0.5;
        pointer-events: none;
      }

      img {
        width: 50px;
      }

      span {
        font-size: getFontSize('body-2');
      }

      .icon {
        cursor: pointer;
      }

      .expired {
        color: red;
      }
    }
  }

  .actions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
</style>
